import React from "react";
import styled from "styled-components";

const StyledMenuItem = styled.button`
  width: 100%;
  padding: 8px 16px;
  background-color: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
  color: #005ba8;
  transition: background-color 0.15s ease;
  display: block;
  line-height: 1.5;

  &:hover {
    background-color: #ebf6ff;
  }

  &:active {
    background-color: #cce5ff;
  }

  &:focus {
    outline: none;
    background-color: #ebf6ff;
  }

  &:focus-visible {
    outline: 2px solid #005ba8;
    outline-offset: -2px;
  }
`;

export interface MenuItemProps {
  /** Unique identifier for the menu item */
  id?: string;
  /** Display label/content for the menu item */
  children: React.ReactNode;
  /** Click handler for the menu item */
  onClick: () => void;
  /** Test ID for testing purposes */
  "data-testid"?: string;
  /** ARIA role */
  role?: string;
  /** Button type */
  type?: "button" | "submit" | "reset";
}

/**
 * MenuItem component for use in dropdown menus
 * A styled button with proper accessibility attributes
 */
export const MenuItem: React.FC<MenuItemProps> = ({
  children,
  onClick,
  "data-testid": testId,
  role = "menuitem",
  type = "button"
}) => {
  return (
    <StyledMenuItem
      data-testid={testId}
      role={role}
      type={type}
      onClick={onClick}
    >
      {children}
    </StyledMenuItem>
  );
};
